module.exports = __webpack_public_path__ + "img/2-7.d7afb3f0.png";